import { KeyedMutator, useSWRFetch } from '@hooks/useSWRFetch';
import { FETCH_STATUS } from '@hooks/useSWRFetch/types';
import {
  buildAlbumUriFromId,
  buildTrackUriFromId,
  isEmptyString,
} from '@helpers/utils';
import { TrackDetailsResponse } from './types';

export const useTrackInfo = (
  albumUri = '',
  trackUri = '',
  fetcher?: Function | undefined,
): {
  data: TrackDetailsResponse | undefined | null;
  error: string | null;
  isValidating: boolean;
  isLoading: boolean;
  mutate: KeyedMutator<any>;
  status: FETCH_STATUS;
  httpStatus: number | undefined;
} => {
  const requestObject = {
    url: `v2/album/${buildAlbumUriFromId(albumUri)}/track/${buildTrackUriFromId(
      trackUri,
    )}/`,
  };

  const canRequest = !isEmptyString(albumUri) && !isEmptyString(trackUri);

  const {
    data,
    error,
    isValidating,
    isLoading,
    mutate,
    ok,
    status: httpStatus,
  } = useSWRFetch<TrackDetailsResponse>(
    canRequest ? requestObject : null,
    {
      dedupingInterval: 0,
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    },
    fetcher ? fetcher : null,
  );

  let status: FETCH_STATUS = FETCH_STATUS.IDLE;

  if (isLoading || isValidating) {
    status = FETCH_STATUS.FETCHING;
  }

  if (error !== null || ok === false) {
    status = FETCH_STATUS.ERROR;
  }

  if (ok && !!data) {
    status = FETCH_STATUS.SUCCESS;
  }

  return {
    data,
    error,
    isValidating,
    isLoading,
    mutate,
    status,
    httpStatus,
  };
};
